import { normalizeTasteTag } from "../../utils/tasteTags.js";

export const BROADER_CATALOG_PICK_COPY = "A nearby match from the wider catalogue.";

function compactTagList(tags = []) {
  const seen = new Set();
  const results = [];

  for (const tag of Array.isArray(tags) ? tags : []) {
    const value = typeof tag === "string" ? tag.trim() : "";
    if (!value) {
      continue;
    }

    const normalized = normalizeTasteTag(value);
    if (seen.has(normalized)) {
      continue;
    }

    seen.add(normalized);
    results.push(value);
  }

  return results;
}

// Picks come from the premiere catalogue, so say so: it's what sets these
// lists apart from all-time "shows like" lists. The anchor's tags are shown
// once, beside it; the sentence names none of them.
export function buildShowsLikeLeadText() {
  return "Recent premieres and returning seasons with a similar mood, humour or pace.";
}

export function buildArchiveTastePrompts(anchor = {}, payload = {}) {
  const sources = [
    ...(Array.isArray(anchor?.displayTasteProfile?.tags) ? anchor.displayTasteProfile.tags : []),
    ...(Array.isArray(anchor?.tasteTags) ? anchor.tasteTags : []),
    ...(Array.isArray(payload?.tasteTags) ? payload.tasteTags : []),
  ];

  return compactTagList(sources).slice(0, 4);
}
